




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { SendProductPaymentReminderMessageFormModel } from '@tools/interfaces/template';
import SendProductPaymentReminderMessage from '@communications/components/forms/product-payment-reminder/send-product-payment-reminder-message.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';

@Component({
  name: 'send-product-payment-reminder-modal',
  components: {
    SendProductPaymentReminderMessage,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class BulkSendPaymentReminderModal extends Vue {
  declare $refs: {
    sendProductPaymentReminderMessage: InstanceType<typeof SendProductPaymentReminderMessage> & {
      formModel: SendProductPaymentReminderMessageFormModel;
    };
  };

  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'modal-send-payment-reminder' }) readonly modalId: string;
  @Prop({ type: String, default: 'subscription' }) readonly entityName: string;
  @Prop({ type: Array, default: () => [] }) readonly contactIds: number[];
  @Prop({ type: Array, default: () => [] }) readonly selectedItemIds: number[];

  isProcessing: boolean = false;
  requestSent: boolean = false;
  successItems: any[] = [];
  errorItems: any[] = [];

  errorPage: number = 1;
  errorPerPage: number = 5;
  errors: Record<string, string[]> = {};

  get modalTitle(): string {
    return this.$t('global.modals.send_product_payment_reminder_message.title').toString();
  }

  get defaultTemplateId(): number | null {
    if (this.entityName === 'subscription') {
      return this.$store.getters['centerSettings/centerSettings']
        ?.subscription_payment_reminder_email_template_id;
    }

    if (this.entityName === 'enrollment') {
      return this.$store.getters['centerSettings/centerSettings']
        ?.enrollment_payment_reminder_email_template_id;
    }

    return null;
  }

  get paginatedErrorItems() {
    const start = (this.errorPage - 1) * this.errorPerPage;
    return this.errorItems.slice(start, start + this.errorPerPage);
  }

  closeModal() {
    this.$emit('close');
    this.reset();
  }

  reset() {
    this.isProcessing = false;
    this.requestSent = false;
    this.successItems = [];
    this.errorItems = [];
    this.errorPage = 1;
  }

  process() {
    this.isProcessing = true;

    const path = this.$bpcApiRouteHelper.getEntityPath('messages');
    const payload = this.$refs.sendProductPaymentReminderMessage.formModel;

    this.$bpcApi.post(`${path}/bulk-send-product-payment-reminder`, payload).subscribe(
      response => {
        this.isProcessing = false;

        const data = response.data || [];
        const errors = (response as any).errors || [];

        this.successItems = data;
        this.errorItems = errors.map((item: any) => ({
          id: item.entity_id,
          code: item.entity_code,
          name: item.entity_name,
          reason: item.error,
        }));
        this.requestSent = true;
      },
      error => {
        this.isProcessing = false;
        this.errors = error?.response?.data?.errors || {};
        this.requestSent = false;
      },
    );
  }
}
